import { Suspense, useEffect } from "react";
import LoadingCallback from "../../LoadingCallback";
import { useDracoGLTF } from "../../../utils/useDracoGLTF";
import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import ChargeIndustries from "./industries/ChargeIndustries";
import Section from "../Section";
import SubSection from "../SubSection";
import { cameraStore } from "../../../appStore";
import { ref } from "valtio";
import ChargeApplications from "./applications/ChargeApplications";
import ChargeProducts from "./products/ChargeProducts";
import { MountAutoplay } from "../../MountAutoplay.tsx";

const ChargeScene = ({ ...props }) => {
  return (
    <group>
      <Suspense fallback={<LoadingCallback />}>
        <ChargeSections />
      </Suspense>
    </group>
  );
};

const ChargeCamPosition = ({ camSettings }) => {
  const { active } = useEbbne();

  useEffect(() => {
    if (active) {
      cameraStore.cameraTargetSettings = ref(camSettings);
    }
  }, [active]);
  return null;
};

const ChargeSections = ({}) => {
  const { nodes, scene } = useDracoGLTF("./models/charge/main.glb");

  return (
    <>
      <ChargeCamPosition camSettings={nodes.CameraTarget} />

      <ChargeIndustries nodes={nodes} />

      <ChargeApplications nodes={nodes} />

      <ChargeProducts nodes={nodes} />

      {import.meta.env.MODE === "electron" && (
        <MountWithEbbne>
          <MountAutoplay path={"guest/autoplay-charge.json"} />
        </MountWithEbbne>
      )}
    </>
  );
};

useDracoGLTF.preload("./models/charge/main.glb");

export default ChargeScene;
